import React from "react";
import { Box, Link, Typography } from "@mui/material";
import "./footer.css";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        zIndex: 100,
        bgcolor: "#f7f9fa",
        textAlign: "center",
        py: 1.5,
        fontSize: 12,
        borderTop: "1px solid #ddd",
        mt: "auto",
      }}
    >
      <Typography sx={{ display: "inline", color: "rgb(142, 142, 147)", fontSize: 12 }}>
        Copyright &copy; Optima Tax Relief, LLC | All Rights Reserved
      </Typography>

      <Box component="span" sx={{ mx: 0.5, display: "inline-block", userSelect: "none" }}>
        &bull;
      </Box>

      <Link
        href="https://optimataxrelief.com/about-us/terms-of-site/"
        target="_blank"
        rel="noreferrer"
        underline="none"
        sx={{
          textDecoration: 'none',
          cursor: 'pointer',
          marginLeft: '3px',
          color: '#1D89D2',
          fontSize: 12,
        }}
      >
        Terms & Conditions
      </Link>

      <Box component="span" sx={{ mx: 0.5, display: "inline-block", userSelect: "none" }}>
        &bull;
      </Box>

      <Link
        href="https://optimataxrelief.com/about-us/privacy/"
        target="_blank"
        rel="noreferrer"
        underline="none"
        sx={{ textDecoration: 'none',
          cursor: 'pointer',
          marginLeft: '3px',
          color: '#1D89D2',
          fontSize: 12, }}
      >
        Privacy Policy
      </Link>
    </Box>
  );
}

export default Footer;

